import lodash from "lodash";
import i18n from "../../i18n";
import store from "../../store";
import { conditionFormChecker, putField } from "../../utils/form";
import { createFieldInput, createFieldInputNumber, createFieldSelect } from "../input/template-builder/template-builder.logic";

export const callAddressType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "ADDRESS_TYPE", value: searchQuery });
export const callProvince = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/province/cacheFindAll", {
        where: [
            { name: "nameTh", operator: "like", value: searchQuery }
        ]
    });
export const callAmphur = ({ provinceId, searchQuery }) =>
    store.dispatch("resource/v1/master/amphur/cacheFindAllByProvince", {
        provinceId,
        where: [
            { name: "nameTh", operator: "like", value: searchQuery },
            { logic: "OR", name: "nameEn", operator: "like", value: searchQuery }
        ]
    });
export const callTambon = ({ amphurId, searchQuery }) =>
    store.dispatch("resource/v1/master/tambon/cacheFindAllByAmphur", {
        amphurId,
        where: [
            { name: "nameTh", operator: "like", value: searchQuery },
            { logic: "OR", name: "nameEn", operator: "like", value: searchQuery }
        ]
    });

export const createForm = (form = {}) => {
    return lodash.merge({
        refAddressType: null, //group ADDRESS_TYPE, key 1
        addrTh: null,
        addrEn: null,
        noTh: null,
        noEn: null,
        roomTh: null,
        roomEn: null,
        buildingTh: null,
        buildingEn: null,
        floorTh: null,
        floorEn: null,
        villageTh: null,
        villageEn: null,
        mooTh: null,
        mooEn: null,
        soiTh: null,
        soiEn: null,
        roadTh: null,
        roadEn: null,
        refProvince: null,
        refAmphur: null,
        refTambon: null,
        postCode: null,
        tel: null,
        email: null,
        fax: null,
        latitude: null,
        longitude: null,
        isValue1: true,
        model: null
    }, form);
};

export const createField = ({ props, data, emit }) => {
    const { viewOnly, dataKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = dataKey ? lodash.get(modelRef, dataKey) : modelRef;
    const prefix = dataKey ? `${dataKey}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refAddressType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refAddressType,
                            "onUpdate:value": value => {
                                model.refAddressType = value;
                                model.isSave = true;
                                emit("updateSome", model);
                            },
                            disabled: viewOnly,
                            list: callAddressType,
                            optLabel: model.isValue1 === true ? "value2" : "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}noTh`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.address.noTh"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.noTh,
                            "onUpdate:value": value => {
                                model.noTh = value;
                                model.isSave = true;
                                emit("updateSome", model);
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}soiTh`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.address.soiTh"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.soiTh,
                            "onUpdate:value": value => {
                                model.soiTh = value;
                                model.isSave = true;
                                emit("updateSome", model);
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}roadTh`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.address.roadTh"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.roadTh,
                            "onUpdate:value": value => {
                                model.roadTh = value;
                                model.isSave = true;
                                emit("updateSome", model);
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}mooTh`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.address.mooTh"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.mooTh,
                            "onUpdate:value": value => {
                                model.mooTh = value;
                                model.isSave = true;
                                emit("updateSome", model);
                            },
                            disabled: viewOnly,
                            comma: false,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refProvince`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.address.refProvince"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.refProvince,
                            "onUpdate:value": value => {
                                model.refProvince = value;
                                model.refAmphur = null;
                                model.refTambon = null;
                                model.postCode = null;
                                model.isSave = true;
                                emit("updateSome", model);
                            },
                            disabled: viewOnly,
                            list: callProvince,
                            renderLabel: ({ item }) => (
                                <div>
                                    {item?.nameTh}
                                </div>
                            )
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refAmphur`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.address.refAmphur"),
                inputProp: ({ field }) => {
                    const defaultDisabled = !model?.refProvince || viewOnly;
                    return lodash.merge(
                        {
                            value: model?.refAmphur,
                            "onUpdate:value": value => {
                                model.refAmphur = value;
                                model.refTambon = null;
                                model.postCode = null;
                                model.isSave = true;
                                emit("updateSome", model);
                            },
                            disabled: defaultDisabled,
                            list: ({ searchQuery }) => callAmphur({ provinceId: model?.refProvince.id, searchQuery }),
                            renderLabel: ({ item }) => (
                                <div>
                                    {item?.nameTh}
                                </div>
                            )
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, defaultDisabled } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refTambon`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.address.refTambon"),
                inputProp: ({ field }) => {
                    const defaultDisabled = !model?.refAmphur || viewOnly;
                    return lodash.merge(
                        {
                            value: model?.refTambon,
                            "onUpdate:value": value => {
                                model.refTambon = value;
                                model.postCode = value ? value.postCode : null;
                                model.isSave = true;
                                emit("updateTambon", value);
                                setTimeout(() => {
                                    emit("updateSome", model);
                                }, 100);
                            },
                            disabled: defaultDisabled,
                            list: ({ searchQuery }) => callTambon({ amphurId: model.refAmphur.id, searchQuery }),
                            renderLabel: ({ item }) => (
                                <div>
                                    {item?.nameTh}
                                </div>
                            )
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, defaultDisabled } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}postCode`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.address.postCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.postCode,
                            "onUpdate:value": value => {
                                model.postCode = value;
                                model.isSave = true;
                                emit("updateSome", model);
                            },
                            disabled: viewOnly,
                            comma: false,
                            maxDecimal: 5
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}email`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.address.email"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.email,
                            "onUpdate:value": value => {
                                model.email = value;
                                model.isSave = true;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}tel`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.address.tel"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.tel,
                            "onUpdate:value": value => {
                                model.tel = value;
                                model.isSave = true;
                            },
                            disabled: viewOnly,
                            comma: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
        ]
    });
};

export const initForm = ({ props, data, refs, emit }) => {
    data.fields = createField({ props, data, refs, emit });
};

export const copyAddressFull = ({ from, to }) => {
    to.noTh = from.noTh;
    to.noEn = from.noEn;
    to.roomTh = from.roomTh;
    to.roomEn = from.roomEn;
    to.buildingTh = from.buildingTh;
    to.buildingEn = from.buildingEn;
    to.floorTh = from.floorTh;
    to.floorEn = from.floorEn;
    to.villageTh = from.billageTh;
    to.villageEn = from.billageEn;
    to.mooTh = from.mooTh;
    to.mooEn = from.mooEn;
    to.soiTh = from.soiTh;
    to.soiEn = from.soiEn;
    to.roadTh = from.roadTh;
    to.roadEn = from.roadEn;
    copyAddressSome({ from, to });
};

export const copyAddressSome = ({ from, to }) => {
    to.refProvince = from.refProvince;
    to.refAmphur = from.refAmphur;
    to.refTambon = from.refTambon;
    to.postCode = from.postCode;
    to.tel = from.tel;
    to.fax = from.fax;
    from.isSave = true;
    to.isSave = true;
};
